export * from './record-icon';
